module.exports = __webpack_public_path__ + "img/Bitmap.fad225a9.png";